import { render, staticRenderFns } from "./OpenAccess.vue?vue&type=template&id=3f81ee12&"
import script from "./OpenAccess.vue?vue&type=script&lang=js&"
export * from "./OpenAccess.vue?vue&type=script&lang=js&"
import style0 from "./OpenAccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports